import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertCircle } from "lucide-react";

interface UndoConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
  title: string;
  description: string;
  itemCount: number;
  totalQuantity: number;
  warningText?: string;
}

const UndoConfirmDialog = ({
  open,
  onConfirm,
  onCancel,
  isLoading,
  title,
  description,
  itemCount,
  totalQuantity,
  warningText,
}: UndoConfirmDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-amber-500" />
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>{description}</p>
              <div className="rounded-md border bg-muted/50 p-3 text-sm">
                <p className="font-medium text-foreground">
                  Impact: {itemCount} SKU{itemCount !== 1 ? "s" : ""}, {totalQuantity} total units
                </p>
              </div>
              <p className="text-amber-600 dark:text-amber-400 text-xs">
                {warningText ?? "This will reverse the quantity changes from this import. Stock levels may have changed since the original upload."}
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading} onClick={onCancel}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isLoading ? "Undoing..." : "Confirm Undo"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default UndoConfirmDialog;
